export const getAudioDurationFromFile = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    const url = URL.createObjectURL(file);
    audio.src = url;
    audio.addEventListener('loadedmetadata', () => {
      URL.revokeObjectURL(url);
      const durationInSeconds = Math.ceil(audio.duration);
      resolve(durationInSeconds);
    });
    audio.addEventListener('error', (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    });
  });
};

export const getAudioDurationFromUrl = (url: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.src = url;
    audio.addEventListener('loadedmetadata', () => {
      const durationInSeconds = Math.ceil(audio.duration);
      resolve(durationInSeconds);
    });
    audio.addEventListener('error', (e) => {
      reject(e);
    });
  });
};
